module.exports = __webpack_public_path__ + "static/media/anti-corruption-plans-2020.8ef783b9.docx";